import { createSlice } from '@reduxjs/toolkit';

interface MockTestState {
  allowNext: boolean; //No next button when waiting time
  isCompleteAudio: boolean; //stop recording in recoring time
}

const initialState: MockTestState = {
  allowNext: false,
  isCompleteAudio: false,
};

export const mockTestSlice = createSlice({
  name: 'mockTest',
  initialState,
  reducers: {
    setAllowNext: (state, action) => {
      state.allowNext = action.payload;
    },
    setIsCompleteAudio: (state, action) => {
      state.isCompleteAudio = action.payload;
    },
  },
});

export const { setAllowNext, setIsCompleteAudio } = mockTestSlice.actions;
export default mockTestSlice.reducer;
